import { GenericLandingCardHeaderInterface } from "../../interfaces";

export const GenericLandingCardHeader = ({
  title,
  subtitle,
  gap = 8,
}: GenericLandingCardHeaderInterface) => {
  return (
    <div className="flex-container column" style={{ gap: `${gap}px` }}>
      <h2>{title}</h2>
      <h5>{subtitle}</h5>
    </div>
  );
};
